<script setup>
    import {defineProps} from "vue";
    import {useBaseStore} from '@/stores/BaseStore';

    const props = defineProps({
        navigation: Array,
    });

    const store = useBaseStore();

    const defaultAvatar = process.env.BASE_PATH + '/avatar.png';
</script>

<template>
    <div>
        <div class="border-b border-gray-200 pb-3 pt-3 mb-3">
            <div class="px-4 flex items-center">
                <div class="flex-shrink-0">
                    <img v-if="store.currentUser.image" class="h-8 w-8 rounded-full" :src="store.currentUser.image"
                         :title="store.currentUser.first_name + ' ' + store.currentUser.last_name"/>
                    <img v-else class="h-8 w-8 rounded-full" :src="defaultAvatar"
                         :title="store.currentUser.first_name + ' ' + store.currentUser.last_name"/>
                </div>
                <div class="ml-3">
                    <div class="text-base font-medium text-gray-800">
                        {{ $tt('user_panel__hi') }} {{ store.currentUser.first_name }}
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-2 pb-3 px-2 space-y-1">
            <span v-for="item in props.navigation" :key="item.name">
                <!-- Use router-link for internal links -->
                <router-link
                    v-if="!item.external"
                    :key="item.name"
                    :to="item.href"
                    :class="[
                        item.current ? 'bg-gray-100 text-gray-900' : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900',
                        'block rounded-md py-2 px-3 text-base font-medium',
                    ]"
                    :aria-current="item.current ? 'page' : undefined"
                >
                    {{ $tt(item.name).toUpperCase() }}
                </router-link>

        <!-- Use regular anchor tag for external links -->
                <a
                    v-if="item.external"
                    :href="item.href"
                    target="_blank" rel="noopener noreferrer"
                    :class="[
                        'text-gray-900 hover:bg-gray-50 hover:text-gray-900',
                        'block rounded-md py-2 px-3 text-base font-medium',
                    ]"
                >
                    {{ $tt(item.name).toUpperCase() }}
                </a>
            </span>
        </div>
    </div>
</template>

